<template>
  <div v-if="isSuperOrSalesUser && !isClosed" class="calendar-test-mode-indicator">
    <span style="margin-right: 8px">
      <span class="label" style="margin-right: 5px">Mode:</span>
      <span
        :class="['mode', isTest ? 'mode--test' : 'mode--default']"
        role="button"
        tabindex="0"
        title="Click to switch modes"
        @click="onToggleClicked"
        @keydown.enter="onToggleClicked"
        @keydown.space.prevent="onToggleClicked"
      >
        {{ displayMode }}
      </span>
    </span>
    <div class="close-btn" type="button" aria-label="Close" title="Hide indicator" @click="onCloseClicked">×</div>
  </div>
  <div v-else class="calendar-test-mode-indicator--hidden"></div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useCalendarTestModeManager } from "@/logic/calendarTestModeManager";
import { useUserProfileStore } from "@stores/userProfileStore";

const { isTest, toggle } = useCalendarTestModeManager();

const userProfileStore = useUserProfileStore();
const isSuperOrSalesUser = computed(() => userProfileStore.isSuperOrSalesUser);

const displayMode = computed(() => (isTest.value ? "Test" : "Live"));

const _STORAGE_KEY_DISMISSED = "shrpa.calendar.testModeIndicator.dismissed";
const isClosed = ref<boolean>(false);
/* try {
  if (typeof window !== "undefined") {
    isClosed.value = sessionStorage.getItem(STORAGE_KEY_DISMISSED) === "1";
  }
} catch {
  // ignore storage errors
}*/

function onToggleClicked() {
  toggle();
  // If the URL hash contains gen=true, remove the entire hash before reloading
  try {
    const rawHash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
    if (rawHash && rawHash.includes("gen=true")) {
      history.replaceState(null, "", window.location.pathname + window.location.search);
    }
  } catch {
    // ignore errors
  }
  window.location.reload();
}

function onCloseClicked() {
  isClosed.value = true;
  /* try {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(STORAGE_KEY_DISMISSED, "1");
    }
  } catch {
    // ignore storage errors
  }*/
}
</script>

<style scoped>
.calendar-test-mode-indicator {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 7px 5px 7px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #555;
  position: relative;
  background-color: #d6d3e8;
}

.label {
  font-weight: bold;
}

.mode {
  padding: 2px 6px;
  margin-right: 2px;
  margin-top: 2px;
  border-radius: 4px;
  border: 1px solid #ccc;
  text-transform: uppercase;
  cursor: pointer;
}

.mode--test {
  background-color: rgba(44, 5, 135, 0.19);
  border-color: rgba(44, 5, 135, 0.35);
  color: #2c0587;
}

.mode--default {
  background-color: #e6fcf5;
  border-color: #63e6be;
  color: #0b7285;
}

.close-btn {
  position: absolute;
  border-radius: 5px;
  border: 1px solid #ccc;
  top: -6px;
  right: -6px;
  width: 16px;
  height: 16px;
  line-height: 14px;
  text-align: center;
  background: #fff;
  font-size: 14px;
  font-weight: bold;
  color: #666;
  cursor: pointer;
}

.close-btn:hover {
  background: #f5f5f5;
}

.calendar-test-mode-indicator--hidden {
  display: none;
}
</style>
